<template>
    <main-content>
        <div class="shadow-sm rounded p-4">
            <action-bar>
                <router-link class="btn btn-success" to="/day-wallets/create"
                             v-text="$t('wallets.btn.create_wallet')"></router-link>
            </action-bar>
            <div class="row my-2">
                <div :key="index" class="col-12 col-md-4 my-2" v-for="(item, index) in wallets">
                    <div class="rounded border text-center py-2 px-3">
                        <div class="row my-2">
                            <div class="col-2">
                                <span :class="`badge badge-${walletStatusVariant(item.status)}`"
                                      v-text="walletStatusStr.get(item.status)">
                                </span>
                            </div>
                            <div class="col-8">
                                <div style="margin:auto;overflow:hidden;width:60px;height:60px;padding:4px;border-radius:100%;border:1px solid #888;">
                                    <img :src="item.logo"
                                         alt="logo"
                                         width="100%">
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="dropdown" v-if="item.status === walletStatus.ACTIVE">
                                    <button class="btn p-0" data-toggle="dropdown" type="button">
                                        <i class="fas fa-list text-muted"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <!-- meysam said we wont offer transfer service yet, so i comment it -->
<!--                                        <router-link :to="`/day-wallets/transfer/${item.id}`" class="dropdown-item"-->
<!--                                                     v-text="$t('wallets.label.transfer')"></router-link>-->
                                        <router-link :to="`/day-wallets/transaction/${item.id}`"
                                                     class="dropdown-item"
                                                     v-text="$t('wallets.label.transaction_reports')">
                                        </router-link>
                                        <router-link :to="`/day-wallets/settlement-list/${item.id}`"
                                                     class="dropdown-item"
                                                     v-text="$t('wallets.label.settlement_reports')">
                                        </router-link>
                                    </div>
                                </div>
                                <div v-else>&nbsp;</div>
                            </div>
                        </div>
                        <div class="my-2" v-text="item.wallet_title"></div>
                        <div class="row my-4" v-if="item.status === walletStatus.ACTIVE">
                            <div class="col-6 my-1">
                                <div class="dropdown">
                                    <button class="btn btn-success dropdown-toggle w-100 d-flex justify-content-around"
                                            data-toggle="dropdown"
                                            type="button" v-text="$t('wallets.label.charge_wlt')">
                                    </button>
                                    <div class="dropdown-menu">
                                        <router-link :to="`/day-wallets/charge/${item.id}`"
                                                     class="dropdown-item"
                                                     v-text="$t('wallets.label.charge_by_direct_payment')"
                                        >
                                        </router-link>
                                        <router-link :to="`/day-wallets/charge-by-oauth/${item.id}`"
                                                     class="dropdown-item"
                                                     v-text="$t('wallets.label.charge_by_oauth2')"
                                        >
                                        </router-link>
                                        <router-link :to="`/day-wallets/charge-by-bill/${item.id}`"
                                                     class="dropdown-item"
                                                     v-text="$t('wallets.label.charge_by_bill')"
                                        >
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 my-1">
                                <router-link :to="`/day-wallets/settlement/${item.id}`"
                                             class="btn btn-outline-success w-100"
                                             v-text="$t('wallets.label.settlement')"></router-link>
                            </div>
                        </div>
                        <div class="line-divider my-4"></div>
                        <div class="mt-4 mb-2">
                            <div class="d-flex align-items-center justify-content-between my-2">
                                <div v-text="$t('wallets.label.id')"></div>
                                <div dir="ltr" v-text="item.id"></div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between my-2">
                                <div v-text="$t('wallets.label.balance')"></div>
                                <div>
                                    <span class="px-1" v-text="item.amount"></span>
                                    <span v-text="$t('wallets.label.rial')"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content.vue';
    import actionBar from '@/components/custom/action-bar';
    import {walletService} from "@/common/api.service";
    import {walletStatus, walletStatusStr, walletStatusVariant} from "@/constants/walletStatus";

    export default {
        components: {
            mainContent,
            actionBar,
        },
        data() {
            return {
                wallets: [],
                walletStatus: walletStatus,
                walletStatusStr: walletStatusStr,
                walletStatusVariant: walletStatusVariant,
            }
        },
        mounted() {
            let params = {
                wallet_prefix: 'D',
            };

            walletService.get(params).then(response => {
                this.wallets = response.data.data;
            });
        }
    }
</script>
